import { combineReducers } from "redux";
import project from "./project";
import projectsList from "./projectsList";

export default combineReducers({
  project,
  projectsList,
});
